import * as actionTypes from "../actions/actionTypes";
import { isAuthenticated } from "../actions/auth";

const initialState = {
  logged_in: isAuthenticated() ? true : false,
  authData: isAuthenticated() || null,
  error: null,
  loading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AUTH_SUCCESS:
      return {
        ...state,
        error: null,
        logged_in: true,
        authData: action.authData,
      };
    case actionTypes.AUTH_FAILED:
      return {
        ...state,
        error: action.error,
        authData: null,
      };
    case actionTypes.LOGOUT:
      return {
        ...state,
        logged_in: false,
        authData: null,
      };
    case actionTypes.SET_PRACTICE_ID:
      return {
        ...state,
        authData: {
          ...state.authData,
          selected_practice: action.id,
          practice_details: action.payload,
        },
      };
    default:
      return state;
  }
};

export default reducer;
